export default __webpack_public_path__ + "static/media/obstacleManagement_icon.429cb85c.webp";